import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

interface ResultState {
  resultImportBestProduct: any;
}

const initialState: ResultState = {
  resultImportBestProduct: {
    "numOfImports": "0",
    "successImportProducts": "0",
    "successUpdateProducts": "0",
    "failedImportProducts": [],
    "duplicateImportProducts": [],
  }
}

export const resultImportBestProductSlice = createSlice({
  name: 'resultImportBestProduct',
  initialState,
  reducers: {
    clear: () => initialState,
    setResult: (state, action) => {
      if (action.payload != 1) {
        state.resultImportBestProduct = action.payload;
      } else {
        clear();
      }
    },
  }
})

export const {
  setResult,
  clear
} = resultImportBestProductSlice.actions

export default resultImportBestProductSlice.reducer
